import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {Library} from '@store/@types/records/Library';
import {SetState} from '@store/@types/util/React';
import {CommentId} from 'records/UserComment';
import {LibraryHighlight} from '@components/call-card/LibraryTabContent.utils';
import {Map} from 'immutable';

interface LibrarySelectProps {
  library: Library | null;
  libraries: Library[];
  setLibrary: SetState<Library | null>;
  setSelectedTags: SetState<string[]>;
  libraryHighlights: Map<CommentId, LibraryHighlight>;
  fetchHighlights: (library: Library) => Promise<void>;
}

export const LibrarySelect: React.FC<LibrarySelectProps> = ({
  fetchHighlights,
  libraries,
  library,
  libraryHighlights,
  setLibrary,
  setSelectedTags,
}) => {
  return (
    <>
      <div className="library-tab-label">Select a Library</div>
      <Autocomplete
        disableClearable
        getOptionLabel={l => l.name}
        getOptionSelected={l => l.id === library?.id}
        options={libraries.filter(l => l.permissions.includes('add'))}
        onChange={(e, library) => {
          setLibrary(library);
          setSelectedTags([]);
          if (library && !libraryHighlights.has(library.id)) {
            fetchHighlights(library).catch(console.error);
          }
        }}
        renderInput={params => (
          <TextField
            className="library-tab-select-input"
            {...params}
            size="small"
            fullWidth={false}
            variant="outlined"
          />
        )}
      />
    </>
  );
};
